import { Container, Box, Typography } from "@mui/material";
import BasicSelect from "./Dropdown";

// the landing page of the app
function Landing() {
  return (
    <>
      <Container align="center" sx={{ display: "flex", justifyContent: "top", flexDirection: "column"}}>
        <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', mt: 5 }}>Welcome to Rock's Kitchen</Typography>
        <Container sx={{ display: "flex", justifyContent: "center", flexDirection: "row"}}>
          <Box
            sx={{ width: 300 }}>
            <BasicSelect></BasicSelect>
          </Box>
        </Container>
      </Container>
      </>
  );
}

export default Landing;